import React from "react";
import { ButtonViewer } from "../viewer/button-viewer";
const Button = ({ componentData, settings, node }) => {
  return /* @__PURE__ */ React.createElement(
    ButtonViewer,
    {
      nodeId: node.attrs.id,
      buttonData: componentData,
      settings
    }
  );
};
export {
  Button
};
//# sourceMappingURL=component.js.map
